import {
  HttpMethod,
  AuthType,
  ApiKeyLocation,
  httpMethods,
  authTypes,
  apiKeyLocationOptions,
} from "./CurlRequest.model";

export function isHttpMethod(value: string): value is HttpMethod {
  return httpMethods.includes(value as HttpMethod);
}

export function isAuthType(value: string): value is AuthType {
  return authTypes.includes(value as AuthType);
}

export function isApiKeyLocation(value: string): value is ApiKeyLocation {
  return apiKeyLocationOptions.includes(value as ApiKeyLocation);
}

/**
 * Skill Lab used to rewrite JSON `{...}` as `${...}` on save. Strip that
 * leading `$` so the editor can parse and persist a valid object again.
 */
export function unwrapMangledJsonBody(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed.startsWith("${") && trimmed.endsWith("}")) {
    return trimmed.slice(1);
  }
  return trimmed;
}
